import { useTranslation } from 'react-i18next';

import mobileQrCodeProd from 'src/assets/mobile-qr-code.png';
import mobileQrCodeTest from 'src/assets/mobile-test-qr-code.png';

const mobileQrCode =
  import.meta.env.VITE_ENVIRONMENT === 'production'
    ? mobileQrCodeProd
    : mobileQrCodeTest;

export const AppbarMobileQrCode = () => {
  const { t } = useTranslation('app');
  const lines = t('appbar.continueOnMobileLines', {
    returnObjects: true,
  });
  const label = t('appbar.continueOnMobile');

  return (
    <div className="hidden items-center px-2 lg:flex">
      <div
        className="flex items-center gap-1.5 rounded border border-gray-200 bg-white px-2 py-1"
        aria-label={label}
      >
        <img
          src={mobileQrCode}
          alt=""
          aria-hidden
          className="h-11 w-11 shrink-0 object-contain"
        />
        <div className="flex flex-col text-[10px] font-medium leading-[1.15] text-shuttleGray-700">
          {lines.map((line) => (
            <span key={line}>{line}</span>
          ))}
        </div>
      </div>
    </div>
  );
};
